import React, { useEffect, useState } from "react";
import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import CTable from "components/common/Table";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import Paper from "components/common/Paper";
import IconButton from "components/common/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import ConnectorTemplate from "../../template/connecter_Template.xlsx"
import { FormControl,InputBase,InputLabel,Select,MenuItem,Chip,Stack,} from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Dialog from "components/common/Dialog";
import DatePickerModal from "components/common/DatePickerModal";
import {OutlinedInput,InputAdornment,} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import FileSaver from "file-saver";
import { ConnectorApiData } from "stores/Connector/ConnectorApi";

const useStyles = makeStyles((theme) => ({
  table_location: {
    "@media (max-width:768px)": {
      width: "100%",
    },
  },
  table_date: {
    "@media (max-width:768px)": {
      width: "218%",
    },
  },
  searchBox: {
    float: "right",
    textAlign: "right",
    alignContent: "flex-end",
    borderRadius: "5px !important",
    "@media (max-width:768px)": {
      float: "none",
      marginTop: "0px",
      marginBottom: "20px",
    },
  },
  menuitem: {
    "@media (max-width:768px)": {
      width: "100%",
    },
  },
  chipmenuitem: {
    alignItems: "center",
    padding: "0px 8px",
    backgroundColor: "unset !important",
    color: "#004AAD",
    marginRight: "10px",
    border: "1px solid #004AAD",
  },
  import: {
    background: "#19AA69",
    color: "white",
    height: "25px",
    padding: "4px 20px",
    borderRadius: "30px",
    marginLeft: "10px",
    cursor: "pointer",
    "@media (max-width:768px)": {
      float: "right",
      position: "relative",
      top: "35px",
    },
  },
  actiontable: {
    display: "flex",
    justifyContent: "start",
    minWidth: "100px",
  },
  ArrowBackIcon: {
    fontSize: "22px",
    color: "black",
    cursor: "pointer",
    fontWeight: "bold",
    marginRight: "5px",
    position: "relative",
    top: "3px",
  },
  Paperalign: {
    p: "2.5px 0",
    display: "flex",
    alignItems: "center",
    width: "250px",
    height: "40px",
  },
  heading: {
    fontSize: "22px",
    marginBottom: "40px",
    color: "#707070",
  },
  containerSelect: {
    marginBottom: "20px",
    height: "3.5rem",
  },
  exportfile: {
    height: "22px",
    background: "#19AA69",
    cursor: "pointer",
    borderRadius: "30px",
    color: "white",
    display: "flex",
    padding: "5px 15px",
  },
}));

const ConnectorType = ({
  ConnectorData,
  limit,
  page,
  handleAddConnnector,
  count,
  handleOpen,
  handleChangeConnnector,
  onPageChange,
  searchhandleChange,
  handleEditConnector,
  isLoading,
  handleChangedate,
  onChange,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,
  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  filterValue,
  handleReset
}) => {
  
  // eslint-disable-next-line no-unused-vars
  let history = useHistory();
  const [fetchexceldata,setFetchExcelData]=useState([])
  useEffect(() => {
    const fetchData = async () => {
      const limit = count;
      try {
        const data = await ConnectorApiData.getbulkexceConnectorDataApi({ limit });
        const Exceldata = data?.result?.connectors;
        setFetchExcelData(Exceldata)
      } catch (error) {
        console.error('Error fetching connector data:', error);
      }
    };
  
    fetchData();
  }, [count]); 
  
  const filteredData = ConnectorData;

  const columns = [
    {
      field: "type",
      headerName: (
        <>
          <span>Connectors Type</span>
        </>
      ),
    },
    {
      field: "name",
      headerName: (
        <>
          <span> Name of Connectors</span>
        </>
      ),
    },
    {
      field: "Action",
      headerName: "Action",
      valueGetter: (v, d) => {
        const manufacturer = {
          id: d?.id,
          name: d?.name,
          type: d?.type,
          thumbnail:d?.thumbnail
        };
        return (
          <>
            {
              <div className={classes.actiontable}>
                <span style={{ marginRight: "30px" }}>
                  <IconButton
                    aria-label="edit"
                    sx={{
                      color: "red",
                    }}
                  >
                    <DeleteOutlineOutlinedIcon
                      sx={{ fontSize: "22px" }}
                      onClick={() =>
                        handleEditConnector("deleteconnectortype", manufacturer)
                      }
                    />
                  </IconButton>
                </span>
                <span>
                  <IconButton
                    variant="outlined"
                    aria-label="edit"
                    sx={{
                      color: "green",
                    }}
                  >
                    <EditOutlinedIcon
                      sx={{ fontSize: "22px" }}
                      onClick={() =>
                        handleEditConnector("editconnector", manufacturer)
                      }
                    />
                  </IconButton>
                </span>
              </div>
            }
          </>
        );
      },
    },
  ];
  const downloadAsExcel = () => {
    const conector = fetchexceldata.map((d) => ({
      'Connectors Type': d?.type,
      'Name of Connectors': d?.name,
    }));
    const worksheet = XLSX.utils.json_to_sheet(conector);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "connector Data");
    XLSX.writeFile(workbook, "ConnectorData.xlsx");
  };

  const downloadVehicleTemplate = () => {
    FileSaver.saveAs(
      ConnectorTemplate,
      'Connector Template.xlsx'
    )
  }
  const classes = useStyles();

  const filter = ["All", "AC", "DC"];
  return (
    <Box className={classes.center} sx={{ marginTop: "1.6rem" }}>
      <Card>
        <CardContent>
          <Stack
            direction={{ sm: "column", xs: "column", md: "row" }}
            spacing={2}
            justifyContent="space-between"
            marginBottom="20px"
          >
            <Text className={classes.heading} variant="h5">
              <ArrowBackIcon className={classes.ArrowBackIcon} />
              CONNECTOR
            </Text>
            <Box sx={{ display: "flex", alignItem: "center" }}>
              <Chip
                onClick={() => handleAddConnnector("AddConnector")}
                className={classes.chipmenuitem}
                label="+ Add Connector "
              />

              <Chip
                onClick={() => handleOpen()}
                className={classes.chipmenuitem}
                label="+ Add Bulk "
              />
               <Chip
                onClick={() => downloadVehicleTemplate()}
                className={classes.chipmenuitem}
                label="Download Template"
              />
              <span
                onClick={() => downloadAsExcel()}
                className={classes.exportfile}
              >
                <FileDownloadIcon
                  sx={{ fontSize: "20px", mt: "3px" }}
                  className={classes.fileDownload_icon}
                />
                Export Report
              </span>
            </Box>
          </Stack>

          <Box className={classes.searchBox}>
            <Paper className={classes.Paperalign}>
              <IconButton type="submit" sx={{ p: "5px" }} aria-label="search">
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="Search by name"
                onChange={(e) =>
                  searchhandleChange("inputsearch", e.target.value)
                }
                inputProps={{ "aria-label": "search" }}
              />
            </Paper>
          </Box>

          <Stack
            className={classes.containerSelect}
            direction={{ sm: "column", xs: "column", md: "row" }}
            spacing={2}
            justifyContent="start"
          >
            <Box sx={{ maxWidth: 143, minWidth: 143 }}>
              <FormControl fullWidth size="small">
                <InputLabel sx={{ fontSize: "14px" }} id="vendor-label">
                  Connector Type
                </InputLabel>
                <Select
                  sx={{ fontSize: "14px" }}
                  labelId="Connector Type"
                  label="Connector Type"
                  className={classes.table_location}
                   value={ filterValue
                      ? filterValue
                      : "All"}
                
                  onChange={handleChangeConnnector}
                >
                  {filter.map((ven, index) => (
                    <MenuItem sx={{ fontSize: "14px" }} key={index} value={ven}>
                      {ven}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ maxWidth: 200, height: '40px',cursor:'pointer'}} >
              <FormControl fullWidth size="small" sx={{cursor:'pointer'}} >
                <InputLabel
                  sx={{ fontSize: "14px",cursor:'pointer' }}
                  className={classes.datePickerInput}
                  id="daterange-label"
                >
                  Date Range
                </InputLabel>
                <OutlinedInput
                  size="small"
                  label="Date Range"
                  sx={{height:'37px',fontSize:'11px'}}
                  className={classes.table_date}
                  id="outlined-adornment-amount"
                  value={
                    fromat_date_from && fromat_date_to
                      ? `${fromat_date_from} - ${fromat_date_to}`
                      : ""
                  }
                  onClick={handleDatePickerOpen}
                  endAdornment={
                    <InputAdornment position="end" sx={{cursor:'pointer'}}>
                      <EventIcon />
                    </InputAdornment>
                  }
                />
              </FormControl>
              <div></div>
            </Box>
            <Dialog
              open={datePickerOpen !== undefined ? datePickerOpen : false}
              onClose={handleDatePickerClose}
              title="Select a date range"

              children={
                <DatePickerModal
                  onClose={handleDatePickerClose}
                  onDatePickerSub={onDatePickerSub}
                  from_date={from_date}
                  to_date={to_date}
                  handleChange={handleChangedate}
                  handleReset={handleReset}
                />
              }
            />
          </Stack>

          <Box className={classes.table}>
            <CTable
              columns={columns}
              data={filteredData ?? []}
              pagination={true}
              count={count }
              page={page}
              rowsPerPage={limit}
              onPageChange={onPageChange}
              isLoading={isLoading}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ConnectorType;
